exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-9f4302fa] {\n    font-style: italic;\n}\n", ""]);

// exports
